import { useState } from 'react';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import { useFundingPageDimensions } from '../../../hooks/useFundingPageDimensions';
import NewFundingDetailsPanel from './details/NewFundingDetailsPanel';
import NewFundingProfilePanel from './profile/NewFundingProfilePanel';

function NewFundingLayout({
  funding,
  consumer,
  bridgePointsBalance,
  totalExpectedBalance,
  setTotalExpectedBalance,
  refreshFundingData,
}) {
  const {
    collapsedMode,
    collapsedPanels,
    setCollapsedPanels,
    expandPanel,
    panelGroupRef,
    detailsRef,
    profileRef,
    toggleProfilePanel,
    collapsedSize,
    minSizes,
    defaultSizes,
  } = useFundingPageDimensions();

  const [spinner, setSpinner] = useState(false);

  return (
    <div className="d-flex flex-column h-100">
      <PanelGroup direction="horizontal" ref={panelGroupRef}>
        <Panel
          ref={detailsRef}
          collapsible
          collapsedSize={collapsedSize}
          minSize={minSizes[0]}
          defaultSize={defaultSizes[0]}
          onCollapse={() => setCollapsedPanels(prev => ({ ...prev, details: true }))}
          onExpand={() => setCollapsedPanels(prev => ({ ...prev, details: false }))}
          style={{ overflowY: 'auto' }}
        >
          <NewFundingDetailsPanel
            collapsedPanels={collapsedPanels}
            expandPanel={expandPanel}
            funding={funding}
            consumer={consumer}
            bridgePointsBalance={bridgePointsBalance}
            totalExpectedBalance={totalExpectedBalance}
            spinner={spinner}
            setSpinner={setSpinner}
            refreshFundingData={refreshFundingData}
          />
        </Panel>
        <PanelResizeHandle className="bo-common-resize-handle-vertical" disabled={collapsedMode} />
        <Panel
          ref={profileRef}
          collapsible
          collapsedSize={collapsedSize}
          minSize={minSizes[1]}
          defaultSize={defaultSizes[1]}
          onCollapse={() => setCollapsedPanels(prev => ({ ...prev, profile: true }))}
          onExpand={() => setCollapsedPanels(prev => ({ ...prev, profile: false }))}
          className="overflow-auto"
        >
          <NewFundingProfilePanel
            collapsedMode={collapsedMode}
            collapsedPanels={collapsedPanels}
            expandPanel={expandPanel}
            toggleProfilePanel={toggleProfilePanel}
            funding={funding}
            consumer={consumer}
            spinner={spinner}
            setSpinner={setSpinner}
            refreshFundingData={refreshFundingData}
            setTotalExpectedBalance={setTotalExpectedBalance}
          />
        </Panel>
      </PanelGroup>
    </div>
  );
}

export default NewFundingLayout;
